import styles from './Login.module.css';

export function Login() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>BalancedArena</h1>
        <p className={styles.subtitle}>Adaptive Quiz Engine</p>

        <a
          href="https://balanced-arena.davidoberger.workers.dev/api/auth/login?screen_hint=sign-up"
          className={styles.button}
        >
          Create Account
        </a>

        <a
          href="https://balanced-arena.davidoberger.workers.dev/api/auth/login"
          className={styles.secondaryButton}
        >
          Sign In
        </a>

        <p className={styles.note}>
          Sign in with Google or Microsoft to get started.
        </p>
      </div>
    </div>
  );
}
